import { render, staticRenderFns } from "./LockSettings.vue?vue&type=template&id=58f79fc4"
import script from "./LockSettings.vue?vue&type=script&lang=js"
export * from "./LockSettings.vue?vue&type=script&lang=js"
import style0 from "./LockSettings.vue?vue&type=style&index=0&id=58f79fc4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports